/* External */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

/* Components */
import PlayerButton from '../PlayerButton/PlayerButton';
import ConditionalVisible from '../ConditionalVisible/ConditionalVisible';

/* Styles */
import './MenuButton.scss';

class MenuButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
    };
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  /**
   * @method handleMouseEnter
   * @description Method that show the menu content.
   */
  handleMouseEnter() {
    this.setState({ isMenuOpen: true });
  }

  /**
   * @method handleMouseLeave
   * @description Method that hide the menu content.
   */
  handleMouseLeave() {
    if (this.wasOpenedWithClick) return;

    this.setState({ isMenuOpen: false });
  }

  /**
   * @method handleClick
   * @description Method that handle toggle the menu content.
   */
  handleClick(event) {
    const { onClick, showOnClick } = this.props;
    event.stopPropagation();
    onClick(event);

    if (showOnClick) {
      this.setState((state) => ({
        isMenuOpen: !state.isMenuOpen,
      }));
    }
  }

  render() {
    const {
      className, children, tooltip, buttonContent, showOnClick,
      id,
    } = this.props;
    const { isMenuOpen } = this.state;

    return (
      <PlayerButton
        className={`dtv-common-c-menu-button-v2 ${className}`}
        tooltip={tooltip}
        onClick={this.handleClick}
        onMouseEnter={showOnClick ? undefined : this.handleMouseEnter}
        onMouseLeave={showOnClick ? undefined : this.handleMouseLeave}
        id={id}
      >
        {buttonContent}
        <ConditionalVisible className="dtv-common-c-menu-button-v2__menu" transitionSeconds={0.5} visible={isMenuOpen}>
          {children}
        </ConditionalVisible>
      </PlayerButton>
    );
  }
}

MenuButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  buttonContent: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  className: PropTypes.string,
  tooltip: PropTypes.string,
  showOnClick: PropTypes.bool,
  onClick: PropTypes.func,
};

MenuButton.defaultProps = {
  children: [],
  buttonContent: [],
  className: '',
  tooltip: '',
  showOnClick: true,
  onClick() {},
};

export default MenuButton;
